import { useState } from "react";
import { subscribe, formatApiErrorDetail } from "@/lib/adminApi";

// One-field signup that lives in the closing section.
export default function NewsletterForm() {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle"); // idle | busy | done | already | error
  const [msg, setMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setState("busy");
    try {
      const res = await subscribe(email);
      setState(res.already ? "already" : "done");
      setEmail("");
    } catch (err) {
      setMsg(formatApiErrorDetail(err.response?.data?.detail) || err.message);
      setState("error");
    }
  };

  if (state === "done" || state === "already") {
    return (
      <p className="newsletter__thanks" data-testid="newsletter-success">
        {state === "already" ? "You're already on the list — thank you." : "Thank you. You'll hear about new work first."}
      </p>
    );
  }

  return (
    <form className="newsletter" onSubmit={submit} data-testid="newsletter-form">
      <label className="newsletter__label mono-caps" htmlFor="newsletter-email">Get updates on new work</label>
      <div className="newsletter__row">
        <input
          id="newsletter-email"
          type="email"
          required
          placeholder="your@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="newsletter__input"
          autoComplete="email"
          data-testid="newsletter-email"
        />
        <button type="submit" className="newsletter__btn mono-caps" disabled={state === "busy"} data-cursor="Join" data-testid="newsletter-submit">
          {state === "busy" ? "…" : "Subscribe"}
        </button>
      </div>
      {state === "error" && <p className="newsletter__error" data-testid="newsletter-error">{msg}</p>}
      <p className="newsletter__note mono-caps">Occasional letters. No noise. Unsubscribe any time.</p>
    </form>
  );
}
